import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { Box, Typography } from '@mui/material'
import { useTheme, styled } from '@mui/material/styles'
import MuiAppBar from '@mui/material/AppBar'

import UserDropdown from './UserDropdown'
import api from 'api'
import { store } from 'reduxStore'
import { useDispatch } from 'react-redux'

import './index.css'
import routes from 'routes'
import Notification from './Notification'
import I18n from 'i18next';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

const Navbar = ({ isDashboard = true }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const user = store.getState().userReducer.user
  const dispatch = useDispatch()

  const [colorChange, setColorchange] = useState(false)
  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(true)
    } else {
      setColorchange(false)
    }
  }

  window.addEventListener('scroll', changeNavbarColor)

  // NOTE: This header should be over the drawer(SideBar) so that we set zIndex as drawer
  return (
    <AppBar
      position="fixed"
      sx={{
        paddingX: 2,
        backgroundColor: theme.palette.background.white,
        zIndex: theme.zIndex.drawer + 1,
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: colorChange ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : 'none',
        flexDirection: 'row',
      }}
    >
      <img
        className="m-2"
        style={{ cursor: 'pointer' }}
        src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
        width={108}
        alt="logo"
        onClick={() => navigate('/')}
      />
      {isDashboard && !location?.pathname?.includes('walkthrough') && (
        <Typography variant="body1" sx={{ color: theme.palette.text.primary }}>
          {I18n.t('header.bannerText')}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Notification />

        <UserDropdown
          user={user}
          onLogout={async () => {
            await api.signOut()
            navigate(routes.auth.signOut)
            dispatch({ type: 'userSignOut' })
          }}
        />
      </Box>
    </AppBar>
  )
}

export default Navbar
